import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_TUTOR_AWARD_CERTIFICATES,
  DELETE_TUTOR_AWARD_CERTIFICATE,
} from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import Template from "containers/Templates/TutorAwardCertificate";
import { getFileName } from "services/Utils";
import GroupTitle from "components/GroupTitle";

const TutorAwardCertificates: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();

  const editItem = (id = "skapa") => {
    navigate(`/certifikat-arets-handledare/${id}`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_tutor_award_certificates", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_tutor_award_certificates", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any) => {
    return (
      <>
        <DownloadButton
          className={classesContentList.actionButton}
          document={<Template item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.tutorAwardCertificate.labels.tutorAwardCertificates}
        operations={{
          category: "certTutorAwardCertificates",
          get: GET_TUTOR_AWARD_CERTIFICATES,
          delete: DELETE_TUTOR_AWARD_CERTIFICATE,
        }}
        labels={{
          deleted:
            I18n.get.tutorAwardCertificate.messages
              .tutorAwardCertificateDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.user.labels.firstname, field: "firstname" },
          { title: I18n.get.user.labels.lastname, field: "lastname" },
          { title: I18n.get.misc.year, field: "year" },
          {
            title: I18n.get.misc.college,
            field: "college",
            width: 200,
            render: (data) => <GroupTitle item={data?.college} />,
          },

          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={
          VoAuth.ability.can("create_own_tutor_award_certificates", "Cert")
            ? editItem
            : undefined
        }
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        actionButtons={getActionButtons()}
        renderActionButtons={getCustomActionButtons}
      />
    </Layout>
  );
};

export default TutorAwardCertificates;
